// Import Rails UJS and Turbo
import Rails from '@rails/ujs'
import '@hotwired/turbo-rails'

// Import and configure Stimulus
import { Application } from 'stimulus'
import DropdownController from '../components/dropdown'
import MonitoringChartController from '../components/monitoring_chart'

// Import jQuery and make it globally available
import $ from 'jquery'
window.$ = window.jQuery = $

// Import Raphael for graphs
import 'raphael'
// Morris.js will be loaded via CDN or separate script tag due to module compatibility issues

// Import our custom JavaScript modules
import '../javascripts/namespace'
import '../javascripts/graphs/graph'
import '../javascripts/graphs/daily_availability'
import '../javascripts/graphs/daily_response_times'
import '../javascripts/graphs/weekly_availability'
import '../javascripts/graphs/weekly_response_times'
import '../javascripts/graphs/monthly_availability'
import '../javascripts/graphs/monthly_response_times'

// Import stylesheet
import '../css/dashboard.css'

// Initialize Rails UJS (only once)
if (!window.Rails) {
  Rails.start()
  window.Rails = Rails
}

// Initialize Stimulus (only once)
if (!window.stimulusApp) {
  const application = Application.start()
  application.register('dropdown', DropdownController)
  application.register('monitoring-chart', MonitoringChartController)
  window.stimulusApp = application
}

// Application-specific JavaScript (from original application.js)
$(function() {
  const setLabelText = function() {
    const $labelElem = $("label[for=monitoring_notifications_attributes_0_destination]");
    const $this = $("#monitoring_notifications_attributes_0_notification_type");
    
    if ($this.val() === "email") {
      $labelElem.text("E-mail Address");
    } else {
      $labelElem.text("WebHook URL");
    }
  };

  setLabelText();
  $("#monitoring_notifications_attributes_0_notification_type").on("change", setLabelText);
});
